// D:\Event\frontend\src\components\id_card.js
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import jsQR from "jsqr";
import { backend_url } from "../constants/backend";

// ⬇️ Popup Component (UNCHANGED)
const Popup = ({ message, type }) => {
  if (!message) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: type === "success" ? "#16a34a" : "#dc2626",
        color: "white",
        padding: "14px 22px",
        borderRadius: 10,
        fontSize: 15,
        fontWeight: 600,
        boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
        zIndex: 9999,
        textAlign: "center",
        maxWidth: "80vw",
      }}
    >
      {message}
    </div>
  );
};

export default function IDCard() {
  const location = useLocation();

  const emailFromState = location?.state?.email || "";
  let email = emailFromState;
  if (!email) {
    try {
      email = sessionStorage.getItem("userEmail") || "";
    } catch {
      email = "";
    }
  }

  // ---- STATES (UNCHANGED) ----
  const [isScanning, setIsScanning] = useState(false);
  
  const [manualCode, setManualCode] = useState("");
  const [scanError, setScanError] = useState("");
 

  const [isVerified, setIsVerified] = useState(false);
  const [idDetails, setIdDetails] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const [showPhotoPopup, setShowPhotoPopup] = useState(false);


  const [popup, setPopup] = useState({ message: "", type: "" });

  const showPopup = (message, type) => {
    setPopup({ message, type });
    setTimeout(() => setPopup({ message: "", type: "" }), 2000);
  };

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const scanIntervalRef = useRef(null);
  const fileInputRef = useRef(null);

  // ==================================================
  // ✅ EXACT CAMERA LOGIC FROM 1st FILE (ONLY CHANGE)
  // ==================================================
  const startScan = async () => {
    setScanError("");
    setManualCode("");
    setIsVerified(false);
    setIdDetails(null);
    setIsScanning(true);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "environment",
          width: { ideal: 640 },
          height: { ideal: 480 },
        },
        audio: false,
      });

      streamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.load();
        videoRef.current.play().catch(() => { });
      }

      scanIntervalRef.current = setInterval(() => {
        if (!videoRef.current?.videoWidth || !canvasRef.current) return;

        const video = videoRef.current;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        ctx.drawImage(video, 0, 0);
        const imageData = ctx.getImageData(
          0,
          0,
          canvas.width,
          canvas.height
        );

        const code = jsQR(
          imageData.data,
          canvas.width,
          canvas.height
        );

        if (code?.data) {
          setManualCode(code.data);
          showPopup("QR Scanned", "success");
          stopScan();
        }
      }, 500);
    } catch (err) {
      console.error("Camera error:", err);
      setScanError("Camera permission denied");
      setIsScanning(false);
    }
  };

  const stopScan = () => {
    setIsScanning(false);

    if (scanIntervalRef.current) {
      clearInterval(scanIntervalRef.current);
      scanIntervalRef.current = null;
    }

    if (streamRef.current) {
      streamRef.current.getTracks().forEach((t) => t.stop());
      streamRef.current = null;
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null;
      videoRef.current.load();
    }
  };

 

  useEffect(() => {
    return () => stopScan();
  }, []);

  // ==== IMAGE SCAN (UNCHANGED) ====
  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setScanError("");
    setIsVerified(false);
    setIdDetails(null);

    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, canvas.width, canvas.height);

        if (code?.data) {
          setManualCode(code.data);
          showPopup("QR Scanned", "success");
        } else {
          showPopup("No QR in Image", "error");
        }
      };

      img.src = reader.result;
    };

    reader.readAsDataURL(file);
    e.target.value = "";
  };

  // ==== VERIFY API (UNCHANGED) ====
  const handleVerify = async () => {
    const valueToVerify = manualCode.trim();

    if (!valueToVerify) {
      showPopup("Please scan or enter QR", "error");
      return;
    }

    setIsVerifying(true);

    try {
      const resp = await fetch(`${backend_url}/verify-idcard/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ qr_code: valueToVerify }),
      });

      const data = await resp.json();

      if (!resp.ok) {
        showPopup(data?.detail || "QR Not Matched", "error");
        setIsVerified(false);
        setIdDetails(null);
      } else {
        setIsVerified(true);
        setIdDetails(data);
        showPopup("QR Matched", "success");
      }
    } catch {
      showPopup("Network Error", "error");
    }

    setIsVerifying(false);
  };

  // ==================================================
  // ⛔ UI BELOW IS COMPLETELY UNCHANGED
  // ==================================================
 return (
  <div>
    <Popup message={popup.message} type={popup.type} />

    <div
      className="react-background"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
      }}
    >
      <div
        style={{
          borderRadius: 16,
          padding: "24px 13px",
          border: "1px solid rgba(148,163,184,0.4)",
          boxShadow: "0 18px 40px rgba(15,23,42,0.8)",
          minWidth: 320,
          maxWidth: 480,
          textAlign: "center",
          marginTop: 62,
        }}
      >
        <h2>ID Card Verification</h2>

        {/* ================= SCAN SECTION ================= */}
        <div
          style={{
            marginTop: 10,
            padding: 12,
            borderRadius: 12,
            border: "1px dashed rgba(148,163,184,0.7)",
          }}
        >
          <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
            <button
              onClick={() => (isScanning ? stopScan() : startScan())}
              style={{
                flex: 1,
                padding: "8px 10px",
                borderRadius: 8,
                border: "none",
                background:
                  "linear-gradient(90deg, rgb(99,102,241), rgb(34,197,94))",
                color: "white",
              }}
            >
              {isScanning ? "Stop Scanning" : "Scan QR"}
            </button>

            <button
              onClick={() => fileInputRef.current.click()}
              style={{
                width: 44,
                borderRadius: 8,
                border: "none",
                background: "#1f2937",
                color: "white",
                fontSize: 18,
                 cursor:"pointer",
              }}
            >
              🖼
            </button>

            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleImageUpload}
            />
          </div>

          {scanError && (
            <p style={{ color: "red", fontSize: 12 }}>{scanError}</p>
          )}

          {isScanning && (
            <video
              ref={videoRef}
              style={{ width: "100%", height: 240, objectFit: "cover" }}
              autoPlay
              muted
              playsInline
            />
          )}

          <canvas ref={canvasRef} style={{ display: "none" }} />

          <input
            value={manualCode}
            onChange={(e) => setManualCode(e.target.value)}
            placeholder="Scan or type QR"
            style={{
              marginTop: 10,
              width: "94%",
              padding: "6px 8px",
              borderRadius: 8,
              border: "1px solid #4b5563",
              background: "#020617",
              color: "white",
            }}
          />

          <button
            onClick={handleVerify}
            disabled={isVerified || isVerifying}
            style={{
              marginTop: 10,
              width: "100%",
              padding: "8px 14px",
              borderRadius: 8,
              border: "none",
              background:
                "linear-gradient(90deg, rgb(99,102,241), rgb(34,197,94))",
              color: "white",
              fontWeight: 600,
              cursor:"pointer",
            }}
          >
            {isVerified ? "Verified" : isVerifying ? "Verifying..." : "Verify"}
          </button>
        </div>

        {/* ================= DETAILS ================= */}
        {idDetails && (
          <div
            style={{
              marginTop: 20,
              padding: "16px 130px 16px 16px",
              borderRadius: 12,
              background: "rgba(15,23,42,0.85)",
              border: "1px solid rgba(148,163,184,0.5)",
              position: "relative",
              textAlign: "left",
            }}
          >
            {/* PHOTO (TOP RIGHT) */}
            {idDetails.photo && (
              <img
                src={
                  idDetails.photo.startsWith("data:image")
                    ? idDetails.photo
                    : `data:image/jpeg;base64,${idDetails.photo}`
                }
                 alt="ID card profile"
                onClick={() => setShowPhotoPopup(true)}
                style={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  width: 90,
                  height: 90,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #22c55e",
                  cursor: "pointer",
                }}
              />
            )}

            <h3 style={{ marginBottom: 10 }}>Details</h3>

            <p><strong>Name:</strong> {idDetails.name}</p>
            <p><strong>Email:</strong> {idDetails.email}</p>
            <p><strong>Mobile:</strong> {idDetails.mobile}</p>
            <p><strong>Company:</strong> {idDetails.company_name}</p>
            <p><strong>Designation:</strong> {idDetails.designation}</p>
            <p><strong>Ref By:</strong> {idDetails.ref_by}</p>
            <p><strong>References:</strong> {idDetails.references}</p>
            <p><strong>Award:</strong> {idDetails.award}</p>
          </div>
        )}
      </div>
    </div>

    {/* ================= PHOTO POPUP ================= */}
    {showPhotoPopup && (
      <div
        onClick={() => setShowPhotoPopup(false)}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.8)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ position: "relative", maxWidth: "90vw", maxHeight: "90vh" }}
        >
          <button
            onClick={() => setShowPhotoPopup(false)}
            style={{
              position: "absolute",
              top: -12,
              right: -12,
              width: 34,
              height: 34,
              borderRadius: "50%",
              border: "none",
              background: "#dc2626",
              color: "white",
              fontSize: 18,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            ×
          </button>

          <img
            src={
              idDetails.photo.startsWith("data:image")
                ? idDetails.photo
                : `data:image/jpeg;base64,${idDetails.photo}`
            }
          alt="ID card profile full view"
            style={{
              maxWidth: "100%",
              maxHeight: "90vh",
              borderRadius: 12,
              objectFit: "contain",
            }}
          />
        </div>
      </div>
    )}
  </div>
);


}
